import React from 'react';
import styles from './WithButton.style';
import PrimaryButton from '../../components/primary-button/PrimaryButton.component';

// This function is a higher-order component that adds a button at the end of the layout

export default function WithButton(Component) {
  const EditedComponent = ({children, buttonProps, ...props}) => {
    const {
      title,
      disabled,
      containerStyle,
      textStyle,
      onPress,
      isLoading,
    } = buttonProps;
    return (
      <Component {...props}>
        {children}
        <PrimaryButton
          title={title}
          disabled={disabled}
          containerStyle={[styles.button, containerStyle]}
          textStyle={textStyle}
          onPress={onPress}
          isLoading={isLoading}
        />
      </Component>
    );
  };
  return React.memo(EditedComponent);
}
